import React from "react";

import { useTranslation } from "react-i18next";

import * as RadixDialog from "@radix-ui/react-dialog";
import { Icon } from "@local-logic/core/icons";
import { useRootElement } from "../context";

import * as styles from "./styles";

export const Dialog = ({
  onReset,
  onApply,
  children,
}: {
  onReset: () => void;
  onApply: () => void;
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation("neighborhoodMap");
  const { isFiltersDialogOpen, setIsFiltersDialogOpen } = useRootElement();

  const handleOnReset = () => {
    onReset();
    setIsFiltersDialogOpen(false);
  };

  const handleOnApply = () => {
    onApply();
    setIsFiltersDialogOpen(false);
  };

  const handleCloseDialog = () => {
    setIsFiltersDialogOpen(false);
  };

  return (
    <RadixDialog.Root open={isFiltersDialogOpen}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className={styles.overlay} />

        <RadixDialog.Content className={styles.content}>
          <RadixDialog.Title className={styles.title}>
            {t("filters.popup.title")}
          </RadixDialog.Title>

          <RadixDialog.Close
            className={styles.close}
            onClick={handleCloseDialog}
          >
            <Icon icon="XCircle" className={styles.closeIcon} />
          </RadixDialog.Close>

          <div className={styles.filters}>
            <RadixDialog.Description className={styles.description}>
              {t("filters.popup.description")}
            </RadixDialog.Description>

            <div className={styles.filterList}>{children}</div>

            <div className={styles.footer}>
              <button className={styles.resetButton} onClick={handleOnReset}>
                {t("filters.popup.cta.reset")}
              </button>
              <button className={styles.saveButton} onClick={handleOnApply}>
                {t("filters.popup.cta.apply")}
              </button>
            </div>
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
